// client/src/api/ApiInterestedUsers.js
import flex from './FlexFetch'

const endpoint = '/api/1.0/interested-users/'

/**
 * Submit an email expressing interest in joining
 * @param {string} email - Email address of interested user
 * @returns {Promise<Object>} Response with success status and message
 */
async function create(email) {
  const response = await flex.flexFetch(endpoint + 'create', {
    method: 'POST',
    body: JSON.stringify({ email }),
  })
  return await flex.handleResponse(response)
}

/**
 * Get all interested users (admin only)
 * @returns {Promise<Array>} Array of interested user records
 */
async function getAll() {
  const response = await flex.flexFetch(endpoint + 'all')
  return await flex.handleResponse(response)
}

const ApiInterestedUsers = { create, getAll }
export default ApiInterestedUsers
